import {NavLink} from 'react-router-dom'
import AppearOnScroll from './AppearOnScroll';


function ProjectCard({ project, isMirrored }) {
    return (
      <AppearOnScroll>
      <NavLink to={`/projects/${project.project_name}`}>
        <div className={`flex ${isMirrored ? 'flex-row-reverse' : 'flex-row'} gap-8  items-center overflow-hidden`}>
              <div className='rounded-image overflow-hidden w-1/2'>
              <img src={`/img/${project.folder}/${project.main_image}`} alt='project' className="object-cover w-full h-full justify-center rounded-image cursor-pointer hover:scale-105 transition-all"/>
              </div>
              <AppearOnScroll delay={0.2}>
              <div className={`flex ${isMirrored ? 'items-end' : 'items-start'} flex-col gap-2 cursor-pointer`}>
                  <h3 className="font-display font-medium text-xl text-dark-900">{project.project_name}</h3>
                  <AppearOnScroll delay={0.3}>
                  <h4 className="font-body font-normal text-base text-dark-700">{project.keywords}</h4>
                  </AppearOnScroll>
              </div>
              </AppearOnScroll>
        </div>
      </NavLink>
      </AppearOnScroll>
    );
  }
  
  export default ProjectCard;